import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    'selector': 'app-crmActivities',
    'templateUrl': './crmActivities.page.html',
    'styleUrls': ['./crmActivities.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class CrmActivitiesPage {

    // constructor() { }

}
